import styled from '@emotion/styled';
import { BodyTextMedium, Button, HeadingText40 } from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Illustration } from 'src/public/img/marginalia-shopping.svg';

const ImageWrapper = styled.div({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'hidden',
    width: '100%',
});

export enum SessionSurveyModalSuccessTestId {
    Title = 'SessionSurveyModalSuccessTestId.Title',
    Description = 'SessionSurveyModalSuccessTestId.Description',
}

interface SessionSurveyModalSuccessProps {
    onClose: VoidFunction;
}

export const SessionSurveyModalSuccess: React.FC<SessionSurveyModalSuccessProps> = ({
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <ImageWrapper>
                <Illustration />
            </ImageWrapper>
            <HeadingText40 testID={SessionSurveyModalSuccessTestId.Title} centered>
                {t('videoSessions:session_survey_modal.thank_you_title')}
            </HeadingText40>
            <BodyTextMedium
                marginBottom={16}
                centered
                testID={SessionSurveyModalSuccessTestId.Description}
            >
                {t('videoSessions:session_survey_modal.thank_you_description')}
            </BodyTextMedium>
            <Button
                variant="primary"
                size="medium"
                fluid
                children={t('videoSessions:session_survey_modal.thank_you_home')}
                onClick={onClose}
            />
        </>
    );
};
